<template>
  <div class="fixed left-0 top-0 w-screen h-screen bg-black/30"></div>
</template>
